module.exports = __webpack_public_path__ + "static/media/building5.01dfc138.svg";